import { render } from "./payments_list.vue?vue&type=template&id=56fe62c4"
import script from "./payments_list.vue?vue&type=script&lang=js"
export * from "./payments_list.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__